// Configuración de URLs
const isDevelopment = process.env.NODE_ENV === 'development'; // Corregido: development, no production

// URL base de la API
export const API_URL = isDevelopment
  ? 'http://localhost:5000/api'
  : 'https://vargashomecenter.pe/api'; // Corregido: sin backticks ni espacios

// URL base para archivos estáticos/uploads
export const UPLOADS_BASE_URL = isDevelopment
  ? 'http://localhost:5000'
  : 'https://vargashomecenter.pe'; // Corregido: sin backticks ni espacios

// Función para obtener la URL completa de una imagen
export const getImageUrl = (imagePath: string | null): string => {
  if (!imagePath) return '/placeholder-image.svg';
  if (imagePath.startsWith('http')) return imagePath;
  if (!imagePath.startsWith('/uploads/')) return imagePath;
  return `${UPLOADS_BASE_URL}${imagePath}`;
};
